import { render, staticRenderFns } from "./CpdReAccreditation.vue?vue&type=template&id=160d6c3a"
import script from "./CpdReAccreditation.vue?vue&type=script&lang=js"
export * from "./CpdReAccreditation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports